import React from "react";
import { StyledWrapper } from "../../../wrappers/StyledWrapper";
import {
  AnalyticsTrackingEvent,
  PopupDrawer,
  ProductPageDialogContent,
  ProductRewardSearchResult,
  SharePage,
} from "@brandclub/common-ui";
import { create } from "zustand";
import { getEntityImage } from "../../../utils";
import DialogContainer from "../DialogContainer";
import { useTrackActions } from "../../../hooks/useTracking";
import { useBCRouting } from "../../../providers/BCRoutingContextProvider";
interface BearState {
  product: ProductRewardSearchResult | undefined;
  open: boolean;
  close: () => void;
  isLoggedOut: boolean;
}

const useConfirmDialogStore = create<BearState>((set) => ({
  product: undefined,
  open: false,
  close: () => set({ open: false }),
  isLoggedOut: false,
}));

export const getShareProductMessage = () => {
  return {
    title: "Share product",
    description: `Copy your personal link to share this product with others.`,
  };
};

const ShareProductDialog = () => {
  const [trackCheckoutBarAction] = useTrackActions();
  const { open, close, product } = useConfirmDialogStore();
  const bcRouting = useBCRouting();

  const productImage = getEntityImage(product?.stacklineSku || "", "product");

  const { title, description } = getShareProductMessage();

  if (!open) {
    return null;
  }
  return (
    <DialogContainer close={close}>
      <div className="dtc-share-dialog">
        <PopupDrawer open={open} onClose={close}>
          <StyledWrapper>
            <ProductPageDialogContent
              title={title}
              subtitle={description}
              imageUrl={productImage}
              imageSize={100}
              sx={{
                paddingBottom: `48px`,
              }}
            >
              <div className="share-container">
                <SharePage
                  url={bcRouting.location.href}
                  onShareLinkCopied={async () => {
                    trackCheckoutBarAction(
                      AnalyticsTrackingEvent.SHARED_AFFILIATE_LINK,
                      {
                        stacklineSku: product?.stacklineSku,
                        retailerId: product?.retailerId,
                        retailerSku: product?.retailerSku,
                      }
                    );
                  }}
                />
              </div>
            </ProductPageDialogContent>
          </StyledWrapper>
        </PopupDrawer>
      </div>
    </DialogContainer>
  );
};

ShareProductDialog.show = (product: ProductRewardSearchResult) => {
  useConfirmDialogStore.setState({
    product: product,
    open: true,
  });
};

export default ShareProductDialog;
